import { actions } from '../constants/video';
import { IAction } from '../../models/action/core';
import * as types from '../../models/action/video';
import { Log } from 'ng2-logger';

const _logger = Log.create('store-action-video');

export function getVideoActivityAction(params: types.IGetVideoActivityActionParams, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetVideoActivityAction {
    return {
        ...params,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_VIDEO_DATA
    };
}

export function setVideoData(activityData: types.ISetVideoActivityDataParams, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetVideoActivityData {
    return {
        ...activityData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_VIDEO_DATA
    };
}

// tslint:disable-next-line:ban-types
export function addVideoGetAction(videoData: types.IVideoInsertData, questionData: types.IVideoQuestionData | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): types.ISetVideoData {
    return {
        videoData,
        questionData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_ADD_VIDEO_DATA,
        callback
    };
}

export function setAddVideoQuestionDataAction(questionData: types.IVideoQuestionData | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetQuestionData {
    return {
        questionData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ADD_VIDEO_QUESTION_DATA
    };
}

export function setVideoQuestionDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ADD_VIDEO_QUESTION_DATA_DEFAULT
    };
}

export function addedVideoActivity(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADDED_VIDEO_ACTIVITY_WITH_MODAL
    };
}